import { render, staticRenderFns } from "./insertimg.vue?vue&type=template&id=ce638bce&scoped=true&"
import script from "./insertimg.vue?vue&type=script&lang=js&"
export * from "./insertimg.vue?vue&type=script&lang=js&"
import style0 from "./insertimg.vue?vue&type=style&index=0&id=ce638bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce638bce",
  null
  
)

export default component.exports